module.exports = __webpack_public_path__ + "static/media/folder.99046de0.svg";